import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import kebabCase from 'lodash/kebabCase'

import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

import VueImg from 'v-img'

import ImageUploader from 'vue-image-upload-resize'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faQuestion, faTimes, faUpload, faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const requireComponent = require.context('./components', false, /\.(vue|js)$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = kebabCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  Vue.component(componentName, componentConfig.default || componentConfig)
})
Vue.component('spinner-1', FulfillingBouncingCircleSpinner)
Vue.use(VueImg, { altAsTitle: false, sourceButton: false, openOn: 'click', thumbnails: false })
Vue.use(ImageUploader)

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)
library.add(faCoffee, faQuestion, faTimes, faUpload, faEdit)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$http = require('./http').default
Vue.prototype.$api = require('./api').default
Vue.prototype.$helpers = require('./helpers').default

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
